import React from 'react'

import { AppContext } from '@/AppContext'

export const useApp = () => React.useContext(AppContext)
